import React from 'react'
import PageHeader from '../../components/PageHeader'
import ShipmentReportDateWiseTable from './ShipmentReportCarrierWiseTable'


const ShipmentReportCarrierWise = () => {
  return (
    <div className="dashboard-container">
      <PageHeader title="Reports:- Shipment Report Carrier wise" hideCalendar={true}/>
      <ShipmentReportDateWiseTable />
    </div>
  )
}

export default ShipmentReportCarrierWise